import * as types from '@/store/mutation-types/'

const mutations = {
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.TAGS] (state, data) {
    state.tags = data.data.data
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.TAGS_ART] (state, data) {
    state.tags_art = data.data.data
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.WORK_MEDIA_TYPE] (state, data) {
    state.work_media_type = data.data.data
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.WORK_PROJECT_TYPE] (state, data) {
    state.work_project_type = data.data.data
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.STORIES_PROJECT_TYPE] (state, data) {
    state.stories_project_type = data.data.data
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.STORIES_TAG] (state, data) {
    state.stories_tag = data.data.data
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/options/mutations.js